/**
 * Centralized color palette for the Solflare HW Customizer.
 * Use these constants in JS/TS; for Tailwind use theme classes (tw-bg-solYellow, etc.)
 */
export const colors = {
  // Brand / accent
  solYellow: "#FFEF46",
  solYellowHover: "#FFE920",
  solYellowDark: "#FFE500",

  // Dark backgrounds
  solBlack: "#030509",
  solBlackHover: "#0a0d12",
  solGray: "#23262B",
  bgDarkest: "#05070a",
  bgDark: "#0C0F14",
  bgDarkElevated: "#0f1115",
  bgDarkModal: "#1a1d23",
  bgDarkPanel: "#1a1c23",
  bgScene: "#1f2129",
  bgDarkHover: "#151821",
  bgToolbar: "#14161b",
  bgInput: "#202227",
  bgSideToggleActive: "#202631",
  bgButtonHover: "#24262b",
  bgSplitButton: "#2a2d35",
  bgSplitButtonHover: "#3a3d45",
  bgScaleTrack: "#32363c",
  bgGrayMuted: "#4a5568",

  // Borders & overlay
  borderLight: "#F5F8FF",
  borderLight20: "#F5F8FF33",
  borderLight40: "#F5F8FF66",

  // Text
  textOnDark: "#f5f8ff",
  textOnDarkSoft: "#e5e7eb",
  textMuted: "#999",
  textMutedLight: "#bbb",
  textDark: "#030303",
  black: "#000",
  white: "#fff",
  offWhite: "#FFFFFC",

  // Light surfaces
  bgLight: "#efefef",
  bgLightMuted: "#E5E5E5",
  bgLightHover: "#E0E0E0",
  bgLightLighter: "#f1f1f1",
  bgLightBorder: "#c1c1c1",
  bgLightBorder2: "#a8a8a8",

  // Status
  success: "#10b981",

  // Canvas guidelines
  guidelineAlign: "rgb(0,255,0)",
  guidelineCenter: "rgba(255,0,241,0.5)",
};
